<template>
  <div>
    <ReportRoom :user="user" ref="ReportRoom"></ReportRoom>
    <PrivacyPolicy ref="PrivacyPolicy"></PrivacyPolicy>
    <FAQ ref="FAQ"></FAQ>

    <v-fade-transition>
      <v-container
        v-if="!user"
        text-center
        style="margin-top: 90px; margin-bottom: 200px"
      >
        <v-layout row align-center>
          <v-row justify="center">
            <v-col cols="12">
              <h1
                class="font-weight-medium mb-1 ml-2 mr-2 white--text display-3"
              >
                Welcome to Trast
              </h1>
              <p
                class="font-weight-regular display-1 mt-3"
                style="color: #64dd17"
              >
                Your no-nonsense streaming platform.
              </p>
              <p
                class="font-weight-light title grey--text mt-6"
                style="line-height: 26px"
              >
                Trast is your new way to watch anything local together with
                anyone.<br />
                From hosting movie nights to remote presentations, there’s no
                end to the possibilities.
              </p>
            </v-col>

            <v-col
              cols="11"
              xs="11"
              sm="10"
              md="11"
              lg="9"
              xl="6"
              :style="{
                'margin-top': $vuetify.breakpoint.xs ? '-140px' : ''
              }"
            >
              <v-carousel hide-delimiters cycle>
                <v-carousel-item v-for="(item, i) in screenshots" :key="i"
                  ><img
                    style="object-fit: contain"
                    width="100%"
                    height="100%"
                    :src="item.src"
                  />
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
          <v-row
            :style="{
              'margin-top': $vuetify.breakpoint.smAndDown ? '-100px' : ''
            }"
          >
            <v-spacer></v-spacer>
            <v-col cols="11" sm="8" md="5" lg="4" class="mt-4 text-left">
              <h1 class="font-weight-medium mb-6 white--text display-2">
                Stream anything,<br />
                to anyone
                <v-icon large color="light-green accent-4"
                  >mdi-television</v-icon
                >
              </h1>
              <p
                class="font-weight-light title grey--text text--lighten-1 mb-6"
                style="line-height: 26px"
              >
                Trast is a low latency, high quality screen sharing platform
                built for movie nights with your friends. If you can watch it
                alone, you can watch it together.<br />
              </p>

              <p
                style="color: #64dd17; display: inline"
                class="font-weight-bold mr-2"
              >
                —
              </p>
              <p
                style="display: inline"
                class="font-weight-bold title white--text"
              >
                Security
              </p>
              <p
                style="display: inline"
                class="font-weight-light title grey--text text--lighten-3 ml-1"
              >
                All your streaming accounts and private information stay local,
                Trast never comes close to them.
              </p>

              <br />
              <br />

              <p
                style="color: #64dd17; display: inline"
                class="font-weight-bold mr-2"
              >
                —
              </p>
              <p
                style="display: inline"
                class="font-weight-bold title white--text"
              >
                We're Free
              </p>
              <p
                style="display: inline"
                class="font-weight-light title grey--text text--lighten-3 ml-1"
              >
                While we have premium relay servers for donators, Peer to Peer
                streams will always be free.
              </p>

              <br />
              <br />

              <p
                style="color: #64dd17; display: inline"
                class="font-weight-bold mr-2"
              >
                —
              </p>
              <p
                style="display: inline"
                class="font-weight-bold title white--text"
              >
                Dedicated Team
              </p>
              <p
                style="display: inline"
                class="font-weight-light title grey--text text--lighten-3 ml-1"
              >
                Our Discord server is full of helpful users and moderators alike
                ready to help.
              </p>
            </v-col>
            <v-spacer></v-spacer>

            <v-col
              cols="11"
              sm="8"
              md="5"
              lg="4"
              class="text-left"
              :class="{
                centered: $vuetify.breakpoint.smAndDown,
                'mt-12': $vuetify.breakpoint.smAndDown,
                'mt-4': !$vuetify.breakpoint.smAndDown
              }"
            >
              <h1 class="font-weight-medium mb-6 white--text display-2">
                Subscriber rooms
                <v-icon large color="light-green accent-4">mdi-signal</v-icon>
              </h1>
              <p
                class="font-weight-light title grey--text text--lighten-1 mb-6"
                style="line-height: 26px"
              >
                Subscribers of Trast unlock a range of new features for their
                streams and experiences.<br />
              </p>

              <p
                style="color: #64dd17; display: inline"
                class="font-weight-bold mr-2"
              >
                —
              </p>
              <p
                style="display: inline"
                class="font-weight-bold title white--text"
              >
                Relay Servers
              </p>
              <p
                style="display: inline"
                class="font-weight-light title grey--text text--lighten-3 ml-1"
              >
                Every Subscriber stream is routed through our bespoke relay
                server, offloading your processing and bandwidth.
              </p>

              <br />
              <br />

              <p
                style="color: #64dd17; display: inline"
                class="font-weight-bold mr-2"
              >
                —
              </p>
              <p
                style="display: inline"
                class="font-weight-bold title white--text"
              >
                Public Rooms
              </p>
              <p
                style="display: inline"
                class="font-weight-light title grey--text text--lighten-3 ml-1"
              >
                Subscribers can host public streams that are advertised on the
                front page.
              </p>

              <br />
              <br />

              <p
                style="color: #64dd17; display: inline"
                class="font-weight-bold mr-2"
              >
                —
              </p>
              <p
                style="display: inline"
                class="font-weight-bold title white--text"
              >
                Custom reactions and GIFS
              </p>
              <p
                style="display: inline"
                class="font-weight-light title grey--text text--lighten-3 ml-1"
              >
                Subscribers can use custom reaction emojis and GIFS.
              </p>
            </v-col>
            <v-spacer v-if="!$vuetify.breakpoint.smAndDown"></v-spacer>
          </v-row>
        </v-layout>
      </v-container>
    </v-fade-transition>
    <v-footer
      v-if="!user"
      absolute
      color="rgb(15,15,15)"
      class="font-weight-light grey--text"
    >
      <v-col class="text-center" cols="12">
        <span :class="{ 'mr-6': !$vuetify.breakpoint.smAndDown }"
          >© Trast, Inc {{ new Date().getFullYear() }}</span
        >
        <v-btn
          class="grey--text ml-2"
          text
          @click="$root.$TermsAndConditions.open()"
          >Terms and Conditions</v-btn
        >
        <v-btn class="grey--text ml-2" text @click="$refs.PrivacyPolicy.open()"
          >Privacy Policy</v-btn
        >
        <v-btn class="grey--text ml-2" text @click="$refs.FAQ.open()"
          >FAQ</v-btn
        >
      </v-col>
    </v-footer>
    <v-slide-x-transition style="height: 100%">
      <v-container
        v-if="user"
        fluid
        fill-height
        :style="listings.length == 0 ? 'height: calc(100vh - 110px)' : ''"
      >
        <v-row no-gutters>
          <v-col cols="12" class="pa-3">
            <h1 class="headline white--text font-weight-bold">
              <v-btn
                icon
                color="white"
                v-if="$vuetify.breakpoint.smAndDown"
                @click.stop="$root.setSidebar(true)"
                ><v-icon>mdi-menu</v-icon></v-btn
              >
              Public Rooms
              <span class="grey--text ml-1 text-subtitle-1">{{
                listings.length
              }}</span>
              <v-btn
                v-if="!isMobile()"
                color="light-green accent-4"
                dark
                style="position: absolute; right: 0"
                class="mr-5"
                :to="user.username"
                ref="openRoomButton"
              >
                Open Room
              </v-btn>
            </h1>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          style="width: 100%; height: 100%"
          :align="listings.length == 0 ? 'center' : ''"
          :class="listings.length == 0 ? 'text-center' : ''"
        >
          <v-col col="12" v-if="listings.length == 0">
            <span class="text-h5 grey--text"
              >There are no public rooms open right now</span
            >
            <p v-if="!isMobile()" class="text-subtitle-1 grey--text">
              Why not start your
              <router-link
                class="text-decoration-none clickable white--text"
                :to="user.username"
                >own</router-link
              >?
            </p>
          </v-col>
          <v-col
            v-for="(listing, index) in listings"
            :key="index"
            sm="6"
            md="6"
            lg="4"
            xl="3"
            class="pa-3"
          >
            <v-card
              class="topRounded clickable"
              v-ripple="{ class: `black--text` }"
              :to="listing.host.username"
              dark
              :color="listing.category.colour"
              elevation="12"
            >
              <v-img
                height="150px"
                width="100vh"
                style="object-fit: cover !important"
                :src="listing.cover"
              >
              </v-img>

              <v-list-item two-line style="width: calc(100% - 52px) !important">
                <v-avatar
                  :color="!listing.host.avatar ? 'rgb(20,20,20)' : ''"
                  class="mr-4"
                >
                  <img v-if="listing.host.avatar" :src="listing.host.avatar" />
                  <span v-else class="white--text text-h6 font-weight-light">{{
                    listing.host.username.substring(0, 2)
                  }}</span>
                </v-avatar>

                <v-list-item-content>
                  <v-list-item-title class="text-h6 font-weight-bold">{{
                    listing.title
                  }}</v-list-item-title>
                  <v-list-item-subtitle class="white--text text-subtitle-1"
                    >@{{ listing.host.username }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <div style="position: absolute; right: 18px; bottom: 22px">
                <v-icon size="28">mdi-account-multiple</v-icon>
                {{ listing.viewers }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-slide-x-transition>
  </div>
</template>

<style>
.topRounded {
  border-top-left-radius: 15px !important;
  border-top-right-radius: 15px !important;
}
</style>

<script>
import { Categories } from "@/tools/config.js";
import ReportRoom from "@/components/reportRoom.vue";
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import FAQ from "@/components/FAQ.vue";

export default {
  components: { ReportRoom,PrivacyPolicy, FAQ },
  data: () => ({
    categories: Categories,
    listings: [],
    search: "",
    searches: [],
    screenshots: [
      { src: require("@/assets/exampleScreenshot3.png") },
      { src: require("@/assets/exampleScreenshot.png") },
      { src: require("@/assets/exampleScreenshot2.png") }
    ]
  }),
  watch: {
    user: function() {
      this.init();
    },
    search: function() {
      this.filterSearches();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init();
    });
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    screenLoader() {
      return this.$store.state.screenLoader;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    init() {
      if (this.user) {
        this.$socket.emit("get initial listings", this.user, listings => {
          this.listings = listings;
        });
        // this.listings.push({
        //   title: "Horror night with Ryn!",
        //   cover:
        //     "https://cdn2.lamag.com/wp-content/uploads/sites/6/2020/10/hallostream.jpg",
        //   viewers: 6,
        //   category: {
        //     name: "Horror",
        //     colour: "red accent-4",
        //   },
        //   host: {
        //     username: "ScientistInsomniac",
        //     avatar: 'https://cdn.discordapp.com/avatars/243905453858357250/a_7c425c8c4f2adbef096ddb522b923b85.webp?size=256',
        //   },
        // });
        // this.listings.push({
        //   title: "Jackbox with the gang!",
        //   cover:
        //     "https://images-eu.ssl-images-amazon.com/images/I/81ff5JVscrL.png",
        //   viewers: 4,
        //   category: {
        //     name: "Games",
        //     colour: "blue",
        //   },
        //   host: {
        //     username: "Chadman",
        //     avatar:
        //       "https://cdn.discordapp.com/avatars/498186030114013186/cee62e3e37cfea6faeef6e9d4d9cd40c.webp?size=256",
        //   },
        // });
        // this.listings.push({
        //   title: "Pixar & Dreamworks!",
        //   cover:
        //     "https://thewaltdisneycompany.eu/app/uploads/2020/08/PixarFestLandscape1_v06-1.jpg",
        //   viewers: 2,
        //   category: {
        //     name: "Chilling",
        //     colour: "orange",
        //   },
        //   host: {
        //     username: "Travall",
        //     avatar:
        //       "https://cdn.discordapp.com/avatars/262655459658432514/b017f09c244ebffbd4fc76cb7ee98358.webp?size=256",
        //   },
        // });
      }
    },
    flagRoom(room) {
      this.$refs.ReportRoom.open().then(object => {
        if (object) {
          object.id = room.id;
          object.author = room.author;
          object.user = this.user;
          object.cover = room.cover;
          object.roomName = room.name;
          this.$socket.emit("report room", object, result => {
            if (result) {
              this.init();
            } else {
              this.$root.$alert("Error", "Your request was unsuccessful.", {
                color: "red"
              });
            }
          });
        }
      });
    }
  }
};
</script>
